export default __webpack_public_path__ + "static/media/SeaLife_34.e3603efa.png";